'use client';
import React from 'react';
import CustomerMobileHome from './components/CustomerMobileHome';

export default function CustomerMobilePage() {
  return <CustomerMobileHome data-component-id="src\app\customer-mobile\page.tsx:6:9" data-component-path="src\app\customer-mobile\page.tsx" data-component-line="6" data-component-end-line="6" data-component-file="page.tsx" data-component-name="CustomerMobileHome" data-component-content="%7B%22elementName%22%3A%22CustomerMobileHome%22%7D" />;
}
